import React, { useState, useEffect } from "react";

import { CSVReader } from "react-papaparse";
import { skaleMainBlue } from "config/UpduoColors";

import { useDispatch } from "react-redux";
import { ActionCreators } from "actions";

export default function DropCSVReader() {
  const dispatch = useDispatch();
  const [file_name, setFileName] = useState("");
  const [fileInfoObject, setFileInfoObject] = useState<Object | String>("");

  const style = {
    dragDrop: {
      height: 100,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  useEffect(() => {
    const newFileName = { file_name: file_name };
    const newFileInfoObject = Object.assign(fileInfoObject, newFileName);
    dispatch(ActionCreators.setFileInfoObject(newFileInfoObject));
  }, [file_name, fileInfoObject, dispatch]);

  const onFileLoad = (array) => {
    const userMetricsArray = array
      .filter((row) => row["errors"].length < 1)
      .map((row) => row["data"]);
    const uploadedCsvDataList = userMetricsArray;
    dispatch(ActionCreators.setUploadedCsvDataList(uploadedCsvDataList));
    const newFileInfoObject: Object = {
      file_name: "temp_file_name",
      row_count: userMetricsArray.length + 1,
      column_count: Object.keys(array[0]["data"]).length,
    };
    setFileInfoObject(newFileInfoObject);
  };

  const onError = (err) => {
    console.log(err);
  };

  return (
    <>
      <CSVReader
        onError={onError}
        onFileLoad={onFileLoad}
        config={{ header: true }}
        progressBarColor={skaleMainBlue}
      >
        {({ file }) => {
          setFileName(file.name);
          return (
            <div style={style.dragDrop}>
              {!file ? <span>{"Drag & drop CSV file here."}</span> : file.name}
            </div>
          );
        }}
      </CSVReader>
    </>
  );
}
